import { Config } from './index';

const config: Config = {
  calculationApiUrl: 'http://localhost:8000/api/v1/calculate',
  debug: true,
  version: '0.0.1',
  environment: 'development'
};

export default config;